import { render, staticRenderFns } from "./page-meta-location.vue?vue&type=template&id=5132765a&scoped=true&"
import script from "./page-meta-location.ts?vue&type=script&lang=ts&"
export * from "./page-meta-location.ts?vue&type=script&lang=ts&"
import style0 from "./page-meta-location.scss?vue&type=style&index=0&id=5132765a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5132765a",
  null
  
)

export default component.exports